import ServiceBase from "base/baseService"
import { boolToNumber, } from "helper/formater"

export default class IcmsCstService extends ServiceBase {

    title = "CST/CSOSN do ICMS"
    pluralTitle = "CST/CSOSNs do ICMS"
    url = '/cadastro/fiscal/icmscst'
    frontUrl = '/cadastro/fiscal/icmscst'
    frontUrlList = '/cadastro/fiscal/icmscstlist'
    primaryKey = 'codigo_icmcst'
    ignoredsSchemaConvertions = ['cod_regit_icmcst']

    prepareToFront(data = {}) {

        data.tem_icms_icmcst = boolToNumber(data.tem_icms_icmcst, true)
        data.tem_st_icmcst = boolToNumber(data.tem_st_icmcst, true)
        data.tem_antec_st_icmcst = boolToNumber(data.tem_antec_st_icmcst, true)
        data.tem_redu_bc_icmcst = boolToNumber(data.tem_redu_bc_icmcst, true)
        data.tem_isencao_icmcst = boolToNumber(data.tem_isencao_icmcst, true)
        data.tem_dir_cred_icmcst = boolToNumber(data.tem_dir_cred_icmcst, true)
        data.tem_difer_icmcst = boolToNumber(data.tem_difer_icmcst, true)

        // Strings notNullable

        data.codigo_icmcst = data?.codigo_icmcst || ''
        data.descricao_icmcst = data?.descricao_icmcst || ''

        return data
    }

    prepareToSave({ data }) {

        return data

    }

}
